import { fetchSupplier } from '@/api/business/supplier'
import { useQuery } from '@tanstack/react-query'

export const supplierKeys = {
    all: ['supplier'] as const,
    lists: () => [...supplierKeys.all, 'list'] as const,
    list: (page: number, perPage: number, filters: any) =>
        [...supplierKeys.lists(), page, perPage, filters] as const,
    details: () => [...supplierKeys.all, 'detail'] as const,
    detail: (params: string) => [...supplierKeys.details(), params] as const,
}

export const useSupplierQuery = () => {
    return useQuery({
        queryFn: fetchSupplier,
        queryKey: supplierKeys.lists(),
    })
}
